export enum OrderTypeEnum {
  STANDARD = "STANDARD",
  PHONE = "PHONE"
}
